export default __webpack_public_path__ + "static/website-logo-23b9bf2aeb792b18b84973f7b58b1b74.png";